import { AvForm, AvField } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap"
import EnvironmentalAudit from "services/EnvironmentalAudit.service"

const user = JSON.parse(localStorage.getItem("authUser"))
const environmentalAuditService = new EnvironmentalAudit(user)

const ConditionsOfApproval = props => {
  const [modal, setModal] = useState(false)
  const [action, setAction] = useState("accept")
  const [rejectionReason, setRejectionReason] = useState("")
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    // console.log("appDetails", props.applicationDetails)
  }, [])

  const toggle = () => setModal(!modal)

  const handleSubmit = () => {
    if (action === "accept") {
      if (confirm("Are you sure you want to ACCEPT the approval conditions?")) {
        environmentalAuditService
          .confirmApprovalConditions(
            props.applicationDetails.application_id,
            true
          )
          .then(response => {
            if (response.status) {
              onSuccess()
            } else {
              onFailure()
            }
          })
      }
    } else if (action === "reject") {
      if (rejectionReason.trim() === "") {
        alert("Please provide a reason for rejection.")
        return
      }
      if (confirm("Are you sure you want to DENY the approval conditions?")) {
        environmentalAuditService
          .rejectApprovalConditions(
            props.applicationDetails.application_id,
            false,
            rejectionReason
          )
          .then(response => {
            console.log(response)
            if (response.status) {
              onSuccess()
            } else {
              onFailure()
            }
          })
      }
    }
  }

  const onSuccess = () => {
    setSuccess(true)
    setError(false)
    window.location.reload()
  }

  const onFailure = () => {
    setSuccess(false)
    setError(true)
  }

  return (
    <div>
      <Alert color="warning">
        Action needed! Your application for Environmental Audit has been
        conditionally approved. Please click on the button below to complete the
        necessary actions.
      </Alert>

      <Button color="info" className="pull-right" onClick={toggle}>
        Complete Actions
      </Button>

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Accept Conditional Approval</ModalHeader>
        <ModalBody>
          <p>
            Please go through the following conditions. A certificate will ONLY
            be generated if you accept these conditions.
          </p>
          <hr />

          <Card>
            <CardBody>
              <div
                dangerouslySetInnerHTML={{
                  __html: props.approval_conditions.conditions,
                }}
              />
            </CardBody>
          </Card>

          <AvForm onValidSubmit={handleSubmit}>
            <FormGroup>
              <Label for="action">Select your action:</Label>
              <p>
                By accepting this EA Approval conditions, I acknowledge and
                accept the terms and conditions outlined above.
              </p>
              <div>
                <Input
                  type="radio"
                  name="action"
                  value="accept"
                  checked={action === "accept"}
                  onChange={() => setAction("accept")}
                />
                <Label className="ms-2">Accept</Label>
              </div>

              <div>
                <Input
                  type="radio"
                  name="action"
                  value="reject"
                  checked={action === "reject"}
                  onChange={() => setAction("reject")}
                />
                <Label className="ms-2">Deny</Label>
              </div>
            </FormGroup>

            {action === "reject" && (
              <FormGroup>
                <Label for="rejectionReason">Reason for Denial:</Label>
                <Input
                  type="textarea"
                  id="rejectionReason"
                  value={rejectionReason}
                  onChange={e => setRejectionReason(e.target.value)}
                  placeholder="Please specify your reason for denyinh the conditions."
                  required={action === "reject"}
                  rows={4}
                />
              </FormGroup>
            )}
            <br></br>

            <Button color="primary" type="submit">
              Submit
            </Button>
          </AvForm>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default ConditionsOfApproval
